export function loading() {
  window.addEventListener('load', function() {
    document.body.classList.add('is-loaded');
  });
}
